import React from 'react';
import { IntlProvider } from 'react-intl';
import * as PropTypes from 'prop-types';
import { messages } from '../../locales/locales';
import { useLanguage } from '../../externals/language';

export const AppIntlProvider = ({ children }) => {
  const [{ currentLanguage }] = useLanguage();
  return <IntlProvider locale={currentLanguage} messages={messages[currentLanguage]}>{children}</IntlProvider>;
};

AppIntlProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
